<app-dashboard-header [title]="'partner portal admin'" [dashboardType]="dashboardType"></app-dashboard-header>
<div class="bg-light-blue w-full pb-6">
  <p class="md:text-3xl text-xl text-center pt-8 pb-4 font-semibold">
    Account Preferences
  </p>
  <div class="change-password-container">
    <a
      class="return-dashboard-button focus:outline-none focus:ring-4 focus:ring-blue-300"
      [routerLink]="['/', dashboardType]"
    >
      <mat-icon>arrow_back</mat-icon>
      <span>Return to Dashboard</span>
    </a>
    <button class="change-password-button focus:outline-none focus:ring-4 focus:ring-blue-300"
      type="button"
      (click)=openChangePasswordModal()
      >
      Change Password
    </button>
  </div>
  <form [formGroup]="accountForm" (ngSubmit)="onPreferencesFormSubmit()" class="max-w-[98%] mx-auto">
    <mat-card class="personal-details-container overflow-x-auto w-full mt-1 mb-8 border-2 p-4 ml-auto mr-auto bg-white" style="border-radius: 8px">
      <mat-card-content>
        <div class="mt-2 mb-4">
          <p class="text-2xl mb-2 font-bold">Personal Information</p>
          <hr class="bg-green h-[3px] border-none">
        </div>
        <div class="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div class="col-span-1">
            <label for="firstName" class="form-label">First Name</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="firstName" required>
              @if (accountForm.get('firstName')?.hasError('required')) {
                <mat-error>First Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="lastName" class="form-label">Last Name</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="lastName" required>
              @if (accountForm.get('lastName')?.hasError('required')) {
                <mat-error>Last Name is required.</mat-error>
              }
            </mat-form-field>
          </div>

          <div class="col-span-1">
            <label for="email" class="form-label">Email Address</label>
            <mat-form-field appearance="outline">
              <input matInput formControlName="email" required email>
              @if (accountForm.get('email')?.hasError('required')) {
                <mat-error>Email is required.</mat-error>
              }
              @if (accountForm.get('email')?.hasError('email')) {
                <mat-error>Please enter a valid email address.</mat-error>
              }
            </mat-form-field>
          </div>
        </div>

        @if (accountForm.dirty) {
          <div class="flex justify-end space-x-4">
            <button class="text-gray-800 bg-gray-300 hover:bg-gray-400 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              style="margin-right: 5px;"
              type="button"
              (click)="onPreferencesCancel()"
              >Cancel
            </button>
            <button class="text-white bg-black hover:bg-blue-800 disabled:opacity-60 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 mr-2 mb-2 focus:outline-none"
              type="submit">Save
            </button>
          </div>
        }
      </mat-card-content>
    </mat-card>
  </form>
</div>
